/**
 * GradientRingButton
 * ─────────────────────
 * CTA con anillo cyan→green (firma Peicar). Outer ring 2px con gradient
 * y inner pill blanco con texto verde.
 *
 * Uso:
 *   <GradientRingButton onClick={handle}><i className="pi pi-plus" /> Nueva</GradientRingButton>
 */
import React from 'react';
import { css } from '@emotion/react';

const FONT = `'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

const ringCSS = css`
    position: relative;
    height: 40px;
    padding: 2px;
    border-radius: 999px;
    background: linear-gradient(to right, #34C6F1, #00BA6E);
    border: none;
    cursor: pointer;
    font-family: ${FONT};
    flex-shrink: 0;
    transition: transform 0.12s ease, box-shadow 0.18s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(0, 186, 110, 0.18);
    }
    &:active:not(:disabled) {
        transform: translateY(0);
    }
    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }

    .grb-inner {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        height: 36px;
        padding: 0 16px;
        border-radius: 999px;
        background: #ffffff;
        color: #1FB874;
        font-size: 13px;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
    }
    .grb-inner i {
        font-size: 13px;
    }
`;

export const GradientRingButton = ({ children, onClick, disabled, type = 'button', title, ...rest }) => (
    <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        title={title}
        css={ringCSS}
        {...rest}
    >
        <span className="grb-inner">{children}</span>
    </button>
);

export default GradientRingButton;
